
export default {
    setTipoVagas(state, data) {
        state.tipoVagas = data
    },
    setTipoVaga(state, data) {
        state.tipoVaga = data
    }
}